import { Component, OnInit, input, output } from '@angular/core';
import {
  fileNameHasSubstring,
  getFileExtension,
} from '../../helpers/file.helper';

@Component({
  standalone: false,
  selector: 'app-whitelabel-ios-provisioning-profiles-upload',
  templateUrl: './whitelabel-ios-provisioning-profiles-upload.component.html',
  styleUrls: ['./whitelabel-ios-provisioning-profiles-upload.component.css'],
})
export class WhitelabelIosProvisioningProfilesUploadComponent
  implements OnInit
{
  public readonly type = input.required<'appProvisionProfile' | 'oneSignalProvisionProfile'>();

  public readonly errorEvent$ = output<void>();

  public readonly successEvent$ = output<File>();

  ngOnInit(): void {}

  public onProvisionUpload(event: any): void {
    const files = event.target.files as FileList;
    const uploadedFile = files[0];

    const pattern = this.type() === 'appProvisionProfile' ? 'App' : 'OneSignal';

    if (this.isProvisioningProfileValid(uploadedFile, pattern)) {
      this.successEvent$.emit(uploadedFile);
      return;
    }

    this.errorEvent$.emit();
    return;
  }

  private isProvisioningProfileValid(
    file: File,
    substringToSearchFor: string
  ): boolean {
    if (file) {
      const fileExtension = getFileExtension(file.name);
      const hasSubstring = fileNameHasSubstring(
        file.name,
        substringToSearchFor
      );

      return fileExtension === '.mobileprovision' && hasSubstring;
    }

    return false;
  }
}
